import {
  Component, Input, Output, EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { SearchResultsRowComponent } from 'shared/search/search-results/search-results-row/search-results-row.component';


@Component({
  moduleId: module.id,
  selector: 'reports-search-results-row',
  templateUrl: 'reports-search-results-row.component.html',
  styleUrls: ['reports-search-results-row.component.scss']
})
export class ReportsSearchResultsRowComponent extends SearchResultsRowComponent {

  @Input() declare timezone: any;
  @Output() downloadClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    protected router: Router,
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

   get isCompleted(): boolean {
     return _.get(this.row, 'status') === 3;
   }

   get isDownloadFailed(): boolean {
     return _.get(this.row, 'download.has_error');
   }

   get downloadLink(): string {
     return _.get(this.row, 'download.link');
   }

   get hasDescription(): string {
     return _.get(this.row, 'description');
   }
}
